<template>
    <div>
        <div class="customer-profile registration-customer-form">
            <div class="content-area">
                <base-header
                class="register-customer-header"
                    :menu-listing="menuListing"
                    step-style
                    @sidemenu="$emit('responsiveSideBar')"
                ></base-header>
                <div class="right-panel">
                    <div class="wrap-content customer-section">
                        <div class="filter-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h2>{{ $route.meta.name }}</h2>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <router-view
                                @openPmdaModal="openPmdaModal"
                            ></router-view>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="card">
                <router-view
                            
                        ></router-view>
            </div> -->
        </div>
        <base-footer style="position: static"></base-footer>
        <b-modal
            ref="pmda"
            size="md"
            title="Warning"
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            
            <pmda-modal @selection="acceptPmda"></pmda-modal>
        </b-modal>

        <!-- <base-footer style="position: static"></base-footer> -->
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

import request from '@/utils/request'
import PmdaModal from '@/components/registration/PmdaModal'
export default {
    components: {
        PmdaModal,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/register-customer/',
                    menuLabel: 'Identity Document',
                    sessionStep: '1',
                    name: 'identity-document',
                    permission: ['register-customer'],
                },
                // {
                //     // anchorLink: '/register-customer/record-video',
                //     menuLabel: 'Record Video',
                //     sessionStep: '3',
                //     name: 'upload-document',
                //     permission: ['register-customer'],
                // },
                {
                    // anchorLink: '/register-customer/setup-profile',
                    menuLabel: 'Setup Profile',
                    sessionStep: '2',
                    name: 'setup-profile',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/account-info',
                    menuLabel: 'Account Info',
                    sessionStep: '3',
                    name: 'account-info',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/kyc',
                    menuLabel: 'KYC',
                    sessionStep: '4',
                    name: 'kyc',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'RPQ',
                    sessionStep: '5',
                    name: 'investment',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'Risk Profile',
                    sessionStep: '6',
                    name: 'risk-product',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'Upload Documents',
                    sessionStep: '7',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/finish',
                    menuLabel: 'Preview',
                    sessionStep: '8',
                    name: 'upload',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/finish',
                    menuLabel: 'Finish',
                    sessionStep: '9',
                    name: 'upload',
                    permission: ['register-customer'],
                },
            ],
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['form', 'dataSegmentId']),
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        // {
        //     // anchorLink: '/register-customer/record-video',
        //     menuLabel: 'Record Video',
        //     sessionStep: '3',
        //     name: 'upload-document',
        //     permission: ['register-customer'],
        // },
        // {
        //   // anchorLink: '/register-customer/setup-profile',
        //   menuLabel: 'Setup Profile',
        //   sessionStep: '2',
        //   name: 'setup-profile',
        //   permission: ['register-customer'],
        // },
    }, // End of Component > methods
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.goToFirstStep()
                this.checkOcrSwitch()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        // console.log("rc main")
        this.$store.commit('updateField', {
            key: 'pmd.pmdInfo.idType',
            value: this.$store.getters.getField('identityInfo.type'),
        })
        this.$store.commit('updateField', {
            key: 'pmd.pmdInfo.idNumber',
            value: this.$store.getters.getField('identityInfo.number'),
        })
        this.$store.commit('updateField', {
            key: 'pmd.pmdInfo.isdCode',
            value: this.$store.getters.getField('contactInfo.isdCode'),
        })
        this.$store.commit('updateField', {
            key: 'pmd.pmdInfo.phoneNumber',
            value: this.$store.getters.getField('contactInfo.phoneNumber'),
        })

        if (this.$route.meta.publicRegistration === true) {
            this.checkDataSegment()
        }
        this.goToFirstStep()
        this.checkOcrSwitch()
        this.$store.commit('initDefaultFields', 'form')
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        acceptPmda() {
            this.$refs.pmda.hide()
        },
        openPmdaModal() {
            const formData = this.$store.state.registration.form
            const pmdInfo = this.$store.state.registration.form.pmd.pmdInfo

            if (
                formData.contactInfo.phoneNumber &&
                formData.identityInfo.number
            ) {
                if (!this.$store.getters.getField('pmdaForm.valid')) {
                    if (
                        pmdInfo.idNumber !== formData.identityInfo.number ||
                        pmdInfo.phoneNumber !== formData.contactInfo.phoneNumber
                    ) {
                        if (
                            formData.identityInfo.type == 'id' &&
                            formData.contactInfo.isdCode == '+92'
                        ) {
                            // this.$refs.pmda.show()
                            this.pmdAPICall()
                        }
                    }
                }
            }
        },
        /**
         * go to the first step
         *
         * @return {void}
         */
        goToFirstStep() {
            if (
                ![
                    'identity-document',
                    'public-registration-identity-document',
                ].includes(this.$route.name)
            ) {
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-identity-document',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push({
                        name: 'identity-document',
                    })
                }
            }
        }, // End of goToFirstStep() method
        /**
         * check if the ocr switch configurations
         * is on for this data segment
         *
         * @return {void}
         */
        async checkOcrSwitch() {
            try {
                let { data } = await request({
                    url: `/configurations/ocr/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
                this.$store.commit('setValue', {
                    key: 'useOcr',
                    value: data.data.switch,
                })
                this.$store.commit('setValue', {
                    key: 'restrictDuplicateCustomers',
                    value: data.data.restrictDuplicateCustomers,
                })
            } catch (error) {
                // console.log(error)
            }
        }, // End of checkOcrSwitch() method

        async checkDataSegment() {
            try {
                const { data } = await request({
                    url: `/configurations/check-dataSegment`,
                    method: 'post',
                    data: { dataSegmentId: this.$route.params.dataSegmentId },
                })

                if (data) {
                    if (data.status == 'fail') {
                        this.$router.push('/404')
                    }
                } else {
                    this.$router.push('/404')
                }
            } catch (error) {
                this.$router.push('/404')
            }
        }, // End of checkOcrSwitch() method

        async pmdAPICall() {
            try {
                // console.log("Full :"+JSON.stringify(this.$store.state.registration.form) )
                let mobileNumber =
                    this.$store.state.registration.form.contactInfo.phoneNumber
                let cnic =
                    this.$store.state.registration.form.identityInfo.number

                let dataSegmentId = this.dataSegmentId

                this.$store.commit('setLoading', true)
                // let phoneNumber = '923333728009'

                const formData = {
                    mobileNumber: mobileNumber,
                    cnic: cnic.replace(/-/g, ''),
                    dataSegmentId: dataSegmentId,
                }

                // console.log('PHONE NUMBER: ' + phoneNumber)
                let encryptedForm = this.CryptoJS.AES.encrypt(
                    JSON.stringify(formData),
                    process.env.VUE_APP_CSK
                ).toString()

                const { data } = await request({
                    url: `/configurations/pmd-verification`,
                    // url:'https://pkdev.idenfo.net/api/configurations/pmd-verification',
                    method: 'post',
                    data: { data: encryptedForm },
                })
                // console.log("data ", JSON.stringify(data))
                if (data) {
                    if (data.data.responseCode == '01') {
                        this.$store.state.registration.form.pmd.pmdVerificationStatus =
                            'Yes'
                        // this.submit2()
                    } else {
                        this.$store.state.registration.form.pmd.pmdVerificationStatus =
                            'No'
                        this.$refs.pmda.show()
                    }
                }

                this.$store.commit('setLoading', true)
            } catch (error) {
                this.$store.state.registration.form.pmd.pmdVerificationStatus =
                    'No'
                // console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of pmdApi() method
    }, // End of Component > methods
} // End of export default
</script>